import styles from './MyInvestment.module.css';
import Card from '../../UI/Card';

const MyInvestment = props => {
  return (
    <Card>
      <h2 className={styles.title}>My Investments</h2>
      <h3>Coming Soon</h3>
    </Card>
  );
};
export default MyInvestment;
